import { badgeArt } from '../../lib/badges';

// A badge's icon in the profile grids. Falls back to the RPC's emoji for any
// badge that has no artwork yet (see lib/badges).
export default function BadgeIcon({ badge, size = 40 }) {
  const src = badgeArt(badge.id);
  if (!src) return <span className="text-2xl" aria-hidden="true">{badge.icon}</span>;
  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      className="object-contain"
      style={{ width: size, height: size }}
    />
  );
}
